<template>
   <svg width="18" height="18" viewBox="0 0 22 23" aria-hidden="true" focusable="false">
      <rect x="0.5" y="0.75" width="21.5" height="21.5" fill="#7010EC" />
      <path
         fill-rule="evenodd"
         clip-rule="evenodd"
         d="M16.1588 3.57715L12.9276 11.6241L12.8422 11.8416H16.4695L19.8872 3.57715H16.1588ZM15.8481 14.7155C15.8481 15.8738 14.9092 16.8127 13.751 16.8127C12.5927 16.8127 11.6538 15.8738 11.6538 14.7155C11.6538 13.5573 12.5927 12.6183 13.751 12.6183C14.9092 12.6183 15.8481 13.5573 15.8481 14.7155ZM2.51939 7.02585L6.30985 15.9428L4.91173 19.205H8.29829L13.3315 6.77729H10.1314L7.92546 12.1523L5.93702 6.77729H2.41064L2.51939 7.02585Z"
         fill="white"
      />
   </svg>
</template>
